import _ from '@luna/lodash';
import type { COUNTRY } from '@shared/core-types';
import {
    features as shared,
    shorthandFeatures as sharedShorthandFeatures,
} from '@shared/transactions-config';

import type {
    RetailTransactionsFeatures,
    RetailTransactionsShorthandFeatures,
} from '../types/RetailTransactionsFeatures';
import { features as base, shorthandFeatures as baseShorthand } from './base';
import { features as AT, shorthandFeatures as shorthandAT } from './countries/AT';
import { features as CZ, shorthandFeatures as shorthandCZ } from './countries/CZ';
import { features as HR, shorthandFeatures as shorthandHR } from './countries/HR';
import { features as HU, shorthandFeatures as shorthandHU } from './countries/HU';
import { features as RO, shorthandFeatures as shorthandRO } from './countries/RO';
import { features as SK, shorthandFeatures as shorthandSK } from './countries/SK';
import { features as RS, shorthandFeatures as shorthandRS } from './countries/RS';

export const features: Record<COUNTRY, RetailTransactionsFeatures> = {
    AT: _.merge({}, shared.AT, base, AT),
    CZ: _.merge({}, shared.CZ, base, CZ),
    HR: _.merge({}, shared.HR, base, HR),
    HU: _.merge({}, shared.HU, base, HU),
    RO: _.merge({}, shared.RO, base, RO),
    SK: _.merge({}, shared.SK, base, SK),
    RS: _.merge({}, shared.RS, base, RS),
};

export const shorthandFeatures: Record<COUNTRY, RetailTransactionsShorthandFeatures> = {
    AT: _.merge({}, sharedShorthandFeatures.AT, baseShorthand, shorthandAT),
    CZ: _.merge({}, sharedShorthandFeatures.CZ, baseShorthand, shorthandCZ),
    HR: _.merge({}, sharedShorthandFeatures.HR, baseShorthand, shorthandHR),
    HU: _.merge({}, sharedShorthandFeatures.HU, baseShorthand, shorthandHU),
    RO: _.merge({}, sharedShorthandFeatures.RO, baseShorthand, shorthandRO),
    SK: _.merge({}, sharedShorthandFeatures.SK, baseShorthand, shorthandSK),
    RS: _.merge({}, sharedShorthandFeatures.RS, baseShorthand, shorthandRS),
};
